import axios from 'axios';
import host from '../global';

const getAuthHeader = () => ({
  Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
});

export const fetchHrProfilesService = async () => {
  const response = await axios.get(`${host}/orgadmin/get_hrprofiles`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const addHrProfileService = async (newHR) => {
  const response = await axios.post(`${host}/orgadmin/addhrprofile`, newHR, {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const updateHrProfileService = async (hrId, updatedHR) => {
  const response = await axios.put(`${host}/orgadmin/updatehrprofile`, updatedHR, {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'application/json',
    },
    params: { hrId },
  });
  return response.data;
};

export const deleteHrProfileService = async (hrId, preserveData) => {
  const response = await axios.delete(
    `${host}/orgadmin/deletehrprofile/${hrId}`,
    {
      headers: getAuthHeader(),
      params: { preserve_data: preserveData },
    },
  );
  return response.data;
};
